import { useState } from "react";
import { useDispatch } from "react-redux";
import { addBlog } from "../slices/blogSlice";

const ModalBlog = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [imagePreview, setImagePreview] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    titleDesc: "",
    description: "",
    headerFile: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, headerFile: file }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // FormData obyekti yarat
    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("titleDesc", formData.titleDesc);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("headerFile", formData.headerFile); // File obyektini əlavə et
  
    // API çağırışını Redux-dan göndər
    const response = await dispatch(addBlog(formDataToSend));
  
    console.log(response);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content  add-modal-for-tour">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
        <h2>Yeni blog Yarat</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="title"
            placeholder="Başlıq"
            value={formData.title}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="titleDesc"
            placeholder="Başlıq açıqlaması"
            value={formData.titleDesc}
            onChange={handleChange}
            required
          />
          <label>Başlıq Şəkli</label>
          <input
            type="file"
            name="headerImageFile"
            accept="image/*"
            onChange={handleImageChange}
          />
          {imagePreview && (
            <img src={imagePreview} alt="Preview" className="image-preview" />
          )}
          <textarea
            name="description"
            placeholder="Təsvir"
            value={formData.description}
            onChange={handleChange}
            required
          />

          <button type="submit" className="submit-btn">
            Yarat
          </button>
        </form>
      </div>
    </div>
  );
};

export default ModalBlog;
